import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect,useParams } from 'react-router-dom';
import { Spin, Space, Row, Col, Divider, List, Avatar, Card, Modal, Tooltip,Table, Image } from 'antd';

import { history } from '../../redux/store';
// import AppointmentsTable from '../../../layout/components/appointmentsTable/AppointmentsTable';
// import hospitalOptions from './charts/hospital-options';
import axios from "axios";
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting'
import logo from '../../assets/img/wss_logo.png';


const VaccinationDetails = () => {

  const [CovidTestData, setCovidTestData] = useState({});
  const [change, setChange] = useState(false);

  const locData = useParams();

  useEffect(() => {

    getVaccData();
    console.log("locData :: ", locData);
    
  }, [])

  function getVaccData() {

    if(locData && locData["vaccId"])
    {
      let custIdArr = [];
      axios.post(setting.serverUrl + '/api/Covid_Vaccination_qr_code', {
        params:
        {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          vacc_id:locData["vaccId"],
        }
      }).then(response => {
          console.log("Respone from getData Covid_Vaccination_qr_code", response.data)
          if (response && response.data && response.data.length>0) {
  
            setCovidTestData(response.data[0]);
            // setCovidTestData(response.data)
            setChange(!change)
          }
      })

    }

  }

  console.log("CovidTestData::",CovidTestData)

  return (
    <div style={{ padding: 30 }}>
      {Object.keys(CovidTestData).length > 0 ?
        <div className='row'>
          <div className='col-md-4'></div>
          <div className='col-md-4'>
            <div style={{ textAlign: 'center', marginBottom:40 }}>
              <i className='fa fa-check' style={{ padding: 5, fontSize: 19, borderRadius: 50, border: '1px solid green', color: 'white', backgroundColor: 'green' }}></i>
              &nbsp;<span style={{ fontWeight: 700, fontSize: 20 }}>VERIFIED!</span>
            </div>
            <Card style={{ background: 'rgba(217, 216, 216)', marginTop: 10 }} className='animated with-shadow'>
            <div><Image src={logo} width={130} /></div>
              <hr style={{width:'100%', height:1, marginBottom:10, marginTop:10}} />
              <div className='count' >
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Name : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.employee.length > 0 && CovidTestData.employee[1]}</span><br />
                {/* <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Client : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.company.length > 0 && CovidTestData.company[1]}</span><br /> */}
                {/* <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Location : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.child_ids.length > 0 && CovidTestData.child_ids[1]}</span><br /> */}
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Provider : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;Workplace Safety Screenings</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Birth date : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.dob && moment(CovidTestData.dob).format("LL")}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Vaccine : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.test_type && CovidTestData.test_type}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Vaccine Date : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.test_date && moment(CovidTestData.test_date).format("LL")}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Dose : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.dose && CovidTestData.dose}</span><br />
                <span style={{fontSize: '1.1em', lineHeight: '2.5em' }}>Lot Number : </span> <span style={{ fontWeight: 700, fontSize: '1.1em', lineHeight: '2.5em' }}> &nbsp;{CovidTestData.lot_no && CovidTestData.lot_no}</span><br />
              </div>
              
            </Card>
            <br />
            <div style={{ fontWeight: 700, fontSize: 17, textAlign: 'center' }}>
              {/* <span >
                To Verify a Covid-19 Vaccination Certificate QR Code, click Scan button.
              </span> */}
            </div>
          </div>

        </div>
        :
        <Row>
          <Col span={10}>
          </Col>
          <Col span={8}>
            <Space size="middle" style={{ marginTop: 40 }}>

              <Spin size="large" />
            </Space>
          </Col>
        </Row>
      }
    </div>
  );
};



export default VaccinationDetails;